import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.DateInputBlock> = (uischema, _schema) => {
  if (uischema.type !== CONTROL_NAME.DATE_PICKER) {
    throw new Error('Expected a valid DatePicker control')
  }

  return {
    type: next.BLOCK_TYPE.DATE_INPUT,
    settings: {
      ...upCommonSettings(uischema),
      fields: uischema.options?.fields,
      disableDays: uischema.options?.disableDays ?? [],
      showTime: Boolean(uischema.options?.showTime),
      timeIntervals: uischema.options?.timeIntervals
    },
    references: {}
  }
}
